// deskKeys — what is in focus on the desk owns its keys: the canvas's
// single-letter tools (studioTools.ts) never act while focus is inside it.
// Esc (unless a field or menu inside took it) goes one level up; in an open
// document, ↑ / ↓ (outside a field or the editor) turn to the previous /
// next document, like its buttons. Plain keys only: a key with a modifier
// is never ours.

export { deskKeyDown };

import type { KeyboardEvent } from "react";

// What owns its own arrows: a field, the editor, an open menu or list.
const ARROW_OWNERS =
    "input, textarea, select, [contenteditable], [role='menu'], [role='listbox']";

const deskKeyDown =
    (
        onClose: () => void,
        flip?: { readonly previous?: () => void; readonly next?: () => void },
    ) =>
    (e: KeyboardEvent<HTMLElement>): void => {
        e.stopPropagation();
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return;
        if (e.key === "Escape") {
            e.preventDefault();
            onClose();
            return;
        }
        if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
        const target = e.target;
        if (target instanceof Element && target.closest(ARROW_OWNERS) !== null)
            return;
        const go = e.key === "ArrowUp" ? flip?.previous : flip?.next;
        if (go === undefined) return;
        e.preventDefault();
        go();
    };
